import { Actions } from "@/components/framework/locationswitcher/locationReducer";
import TheatreButton from "@/components/framework/locationswitcher/TheaterButton";
import ListItem from "@/components/framework/plainlist/ListItem";
import PlainList from "@/components/framework/plainlist/PlainList";
import RegionTheaters from "@/lib/client/RegionTheaters";
import { ActionDispatch, useMemo } from "react";
import styles from "./LocationSearchResult.module.css";

//#region [Props]
type LocationSearchResultProps = {
    regionTheaters?: RegionTheaters[];
    searchString: string;
    dispatch: ActionDispatch<[action: Actions]>;
};
//#endregion



//#region [Component]
export default function LocationSearchResult({ regionTheaters, searchString, dispatch }: LocationSearchResultProps) {
    const theaters = useMemo(() => {
        return regionTheaters?.flatMap(r => r.theaters);
    }, [regionTheaters]);
    const result = useMemo(() => {
        // flatten into theaters
        const result = theaters?.filter(th => {
            const r = new RegExp(searchString, "i");
            return r.test(`${th.name}|${th.poststed}|${th.location ?? ""}`);
        });
        return result?.slice(0, 9);

    }, [theaters, searchString]);

    return <div className={styles.SearchResultContainer}>
        {searchString !== "" && <>
            {(result?.length ?? 0) === 0 && <>Ingen treff</>}
            {(result?.length ?? 0) > 0 && <PlainList>
                {result?.map(th => <ListItem key={th.teaternr}><TheatreButton theater={th} dispatch={dispatch} /></ListItem>)}
            </PlainList>}

        </>}
    </div>;
}
//#endregion

//#region [Styles]

//#endregion